var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comparer-signs"},[_c('div',{staticClass:"comparer-a",class:{ winner: _vm.winner === 'a' }},[_vm._v("A")]),_c('div',{staticClass:"comparer-b",class:{ winner: _vm.winner === 'b' }},[_vm._v("B")])])}
var staticRenderFns = []

export { render, staticRenderFns }